module.exports = __webpack_public_path__ + "media/images/talent/flow-image02-f3db6bf99139e531a6ba65a42bcfce53.png";